import React, { useState } from 'react';
import img from '../../screenshots/formal-4.jpg';
import linkedIn from '../../screenshots/linkedIn.png';
import medium from '../../screenshots/medium.png';
import github from '../../screenshots/github.png';
import MessageForm from '../MessageForm/MessageForm';

const AboutMe = () => {
    const [modalIsOpen, setIsOpen] = useState(false);
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const openModal = async () => {
        await wait(200);
        setIsOpen(true);
    }

    const closeModal = async () => {
        await wait(200);
        setIsOpen(false);
    }

    return (
        <section data-aos="zoom-in-down" className="project-container mt-5 pb-5 mw-100 mb-0" id="about">
            <div className="caption mb-5" style={{ color: '#e94256' }}>About Me</div>
            <div className="d-flex justify-content-center align-items-center flex-column mt-5">
                <img src={img} alt="" className="" style={{ borderRadius: "50%" }} width="150px" />
                <div className="m-4">
                    <a href="https://www.linkedin.com/in/kazi-mashry-902335152/" target="blank">
                        <img src={linkedIn} alt="" className="img-fluid m-2" />
                    </a>
                    <a href="https://kazi-mashry.medium.com/" target="blank">
                        <img src={medium} alt="" className="img-fluid m-2" />
                    </a>
                    <a href="https://github.com/kaziMashry" target="blank">
                        <img src={github} alt="" className="img-fluid m-2" />
                    </a>
                </div>
                <p style={{ width: "300px", textAlign: "center", fontWeight: "400" }}>
                    I'm a passionate programmer who likes to slove problems and explore technologies. Currently I'm studing B.Sc. in Computer Science and Engineering. Besides programming, I love to solve mathematical problems and watch cricket I'm a big fan of England cricket.
                </p>
                <div className="header-button-container d-flex flex-wrap justify-content-center">
                    <button type="button" className="btn btn-light ml-2 mt-3" onClick={openModal}>
                        Send Message
                </button>

                    <a className="text-decoration-none" style={{ color: '#f5f5f7' }} href="https://drive.google.com/uc?export=download&id=1fMBG5_W4IFeg4qeYRuDA6jNetPqrfMYk" target="blank">
                        <button type="button" className="btn btn-dark ml-2 mt-3">Download Resume</button>
                    </a>
                    <MessageForm modalIsOpen={modalIsOpen} closeModal={closeModal} />
                </div>
            </div>
        </section>
    );
};

export default AboutMe;